var map = {
	"./template.bet777": 1948,
	"./template.bet777.tsx": 1948,
	"./template.betgalaxy": 1949,
	"./template.betgalaxy.tsx": 1949,
	"./template.betprofessor": 1950,
	"./template.betprofessor.tsx": 1950,
	"./template.chromabet": 1951,
	"./template.chromabet.tsx": 1951,
	"./template.default": 340,
	"./template.default.tsx": 340,
	"./template.gigabet": 2130,
	"./template.gigabet.tsx": 2130,
	"./template.pyramidbet": 2017,
	"./template.pyramidbet.tsx": 2017,
	"./template.slambet": 1952,
	"./template.slambet.tsx": 1952,
	"./template.ts": 1001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2796;